<template>
  <div>
    <search-supplier-profile @submit="submitSearch" />

    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :scroll="{ x: 'max-content' }"
      :pagination="false"
      row-key="id"
    />

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import { findProfileSupplierProfiles } from '@/api/profile_supplier'
import Pagination from '@/components/Pagination'
import SearchSupplierProfile from '@/views/profiles/supplier/Search'
import { formatFloat } from '@/utils/filter'

export default {
  name: 'SupplierProfileList',
  components: {
    Pagination,
    SearchSupplierProfile
  },
  data() {
    return {
      data: [],
      loading: true,
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  computed: {
    profileSupplierId() {
      return parseInt(this.$route.params.id)
    },
    columns() {
      return [
        { title: 'ICCID', dataIndex: 'iccid', width: 200, fixed: 'left' },
        { title: 'MSISDN', dataIndex: 'msisdn', width: 140 },
        { title: '激活码', dataIndex: 'activation_code', width: 220, ellipsis: true },
        { title: 'MatchingID', dataIndex: 'matching_id', width: 160, ellipsis: true },
        { title: 'SM-DP+地址', dataIndex: 'smdp_address', width: 160, ellipsis: true },
        { title: 'SM-DP+平台', dataIndex: 'smdp_platform_name', width: 120 },
        { title: 'SGP协议', dataIndex: 'sgp_spec_name', width: 100 },
        { title: 'ProfileType', dataIndex: 'profile_type', width: 180, ellipsis: true },
        { title: 'PRP规则', dataIndex: 'prp_id_text', width: 200 },
        { title: '状态', dataIndex: 'status_text', width: 120 },
        { title: '下载次数', dataIndex: 'download_counter', width: 100 },
        { title: '首次下载时间', dataIndex: 'first_download_date', width: 160 },
        { title: '设备', dataIndex: 'device', width: 140, ellipsis: true },
        { title: 'EID', dataIndex: 'eid', width: 220, ellipsis: true },
        { title: 'eIM平台', dataIndex: 'eim_platform_name', width: 120 },
        { title: 'eIM注册状态', dataIndex: 'eim_register_status_name', width: 120 },
        { title: '状态（EIM）', dataIndex: 'eim_status_text', width: 120 },
        { title: '重复下载规则（EIM）', dataIndex: 'eim_prp_code_name', width: 180 },
        { title: '产品名称', dataIndex: 'product_name', width: 160 },
        {
          title: 'Profile费(元)',
          dataIndex: 'profile_fee',
          width: 120,
          customRender: (t) => formatFloat(t)
        },
        { title: '备注', dataIndex: 'remark', width: 160, ellipsis: true },
        { title: '划拨时间', dataIndex: 'allocated_at', width: 170 },
        { title: '所属客户', dataIndex: 'agent_name', width: 160 },
        { title: '订单号', dataIndex: 'order_no', width: 160 }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search
      )
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findProfileSupplierProfiles(this.profileSupplierId, this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    }
  }
}
</script>
